import { useDispatch, useSelector } from "react-redux";
import { dismissModal } from "../reducers/modal/modal.actions";
import { RootState } from "../store/rootReducer";

export const Modal = () => {
  const dispatch = useDispatch();

  const title =  useSelector((state: RootState) => state.modal.title);
  const isVisible = useSelector((state: RootState) => state.modal.visible);
  const description =  useSelector((state: RootState) => state.modal.description);

  const close = () => {
    dispatch(dismissModal());
  }

  return (
    <div className={`modal ${isVisible ? 'show' : ''}`} id="modal-default">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={close} aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 className="modal-title">{title}</h4>
          </div>
          <div className="modal-body">
            <p dangerouslySetInnerHTML={{__html: description}}></p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={close}>Tutup Pesan</button>
          </div>
        </div>
      </div>
    </div>
  );
}